module.exports = __webpack_public_path__ + "img/banner-princiapal.7befe9f8.png";